/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useMemo } from "react";
import { BulkResponseHandler } from "../../components/BulkResponseHandler";
import { NotificationItem } from "../../components/NotificaionItem";
import {
  useFetchAdminNotificationsData,
  useFetchNotificationsData,
} from "../../apis/notificationApis";
import RoleToggle from "../../components/RoleToggle";
import NoDataFound from "../../components/common/NoDataFound";
import { IconDownload } from "@tabler/icons-react";


const NotificationView: React.FC = () => {
  const roles = ["All", "Read", "Unread"];
  const [activeRole, setActiveRole] = useState("All");
  const [searchFor, setSearchFor] = useState("");
  const [pageNo] = useState(1);
  const [limit] = useState(10);
  const [openResponse, setOpenResponse] = useState(false);
  const [bulkJobId, setBulkJobId] = useState("");
  const [notification, setNotification] = useState<any>(null);

  const { data, refetch: fetchNotifications } = useFetchAdminNotificationsData(
    pageNo,
    limit,
    searchFor,
  );

  const filteredNotifications = useMemo(() => {
    if (!data?.notifications) return [];
    switch (activeRole) {
      case "Read":
        return data.notifications.filter((n: any) => n.adminSeen);
      case "Unread":
        return data.notifications.filter((n: any) => !n.adminSeen);
      default:
        return data.notifications;
    }
  }, [data, activeRole]);

  const groupedNotifications = useMemo(() => {
    const groups: Record<string, any[]> = {};
    const today = new Date().toDateString();
    filteredNotifications.forEach((n: any) => {
      const nDate = new Date(n.created_at).toDateString();
      const key = nDate === today ? "today" : nDate;
      if (!groups[key]) groups[key] = [];
      groups[key].push(n);
    });
    return groups;
  }, [filteredNotifications]);

  const hasNotifications = filteredNotifications.length > 0;

  const handlePdfDownload = (url?: string) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div className="p-4 lg:w-10/12 w-11/12 mx-auto space-y-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-medium tracking-[0.5px] text-[#212121]">
            All Notifications
          </h1>
          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        </div>
        {hasNotifications ? (
          <>
            {(groupedNotifications.today ?? []).map((n: any) => (
              <div
                key={n.id}
                className="rounded-lg bg-[#F7F6F2] flex items-center justify-between"
                onClick={() => {
                  if (n.title === "Bulk Job Completed") {
                    setBulkJobId(n.referenceId);
                    setNotification(n);
                    setOpenResponse(true);
                  }
                }}
              >
                {/* Left */}
                <div className="flex-1">
                  <NotificationItem n={n} onClick={() => {}} showDot={false} />
                </div>

                {/* Right – Download button */}
                {n.title === "Bulk PDF Ready" && n.bulkJobFileUrl && (
                  <button
                    className="mr-4 bg-[#212121] text-white px-3 py-1.5 rounded-md text-xs"
                    onClick={(e) => {
                      e.stopPropagation(); // 🔥 important
                      handlePdfDownload(n.bulkJobFileUrl);
                    }}
                  >
                    <IconDownload/>
                  </button>
                )}
              </div>
            ))}

            {Object.entries(groupedNotifications)
              .filter(([k]) => k !== "today")
              .map(([date, items]) => (
                <div key={date} className="space-y-4">
                  <p className="text-sm text-[#212121]/70 text-center">
                    {date}
                  </p>
                  {items.map((n: any) => (
                    <div
                      key={n.id}
                      className="rounded-lg bg-[#F7F6F2] flex items-center justify-between"
                      onClick={() => {
                        if (n.title === "Bulk Job Completed") {
                          setBulkJobId(n.referenceId);
                          setNotification(n);
                          setOpenResponse(true);
                        }
                      }}
                    >
                      <div className="flex-1">
                        <NotificationItem
                          n={n}
                          onClick={() => {}}
                          showDot={false}
                        />
                      </div>

                      {n.title === "Bulk PDF Ready" && n.bulkJobFileUrl && (
                        <button
                          className="mr-4 bg-[#212121] text-white px-3 py-1.5 rounded-md text-xs"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePdfDownload(n.bulkJobFileUrl);
                          }}
                        >
                         <IconDownload/>
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              ))}
          </>
        ) : (
          /* Show No Data Found only when there are no notifications */
          <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] p-8 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]">
            <NoDataFound
              title="No Notifications Found"
              message="Check back later or try adjusting your filters."
              mainClassName="rounded-3xl"
              subClassName="bg-transparent"
            />
          </div>
        )}
      </div>
      {openResponse && (
        <BulkResponseHandler
          isOpen={openResponse}
          onClose={() => setOpenResponse(false)}
          bulkJobId={bulkJobId}
          notification={notification}
        />
      )}
    </>
  );
};

export default NotificationView;
